import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { useAuth } from "hooks";
import { APPLICANT_TYPES } from "constants/index";
import { ApplicantsShareButton } from "components/Missions/Applicants";

/**
 * ApplicantSelectedCount
 *
 * @param {Array}   selected
 * @param {String}  applicantState
 */
const ApplicantSelectedCount = ({ selected = [], applicantState, ...props }) => {
  const { isAdmin } = useAuth();

  if (!isAdmin) return null;
  if (applicantState === APPLICANT_TYPES.recommended) return null;
  if (applicantState === APPLICANT_TYPES.invited) return null;

  return (
    <div css={styles.selected_count_container} {...props}>
      {selected.length > 0 && (
        <span css={styles.selected_count}>
          <FormattedMessage id="Missions.Applicants.ApplicantList.SelectedCount" values={{ count: selected.length }} />
        </span>
      )}
      <ApplicantsShareButton selected={selected} disabled={selected.length === 0} />
    </div>
  );
};

const styles = {
  selected_count: css`
    font-weight: 500;
  `,
  selected_count_container: css`
    display: flex;
    align-items: center;
    gap: 1rem;
  `,
};

ApplicantSelectedCount.propTypes = {
  selected: PropTypes.array.isRequired,
  applicantState: PropTypes.string.isRequired,
};

export default ApplicantSelectedCount;
